import Icon from '../components/Icon.vue'

Icon.register({
  'square-root-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M571.3 251.3c6.3 6.3 6.3 16.4 0 22.6l-46.1 46.1 46.1 46.1c6.3 6.3 6.3 16.4 0 22.6l-22.6 22.6c-6.3 6.3-16.4 6.3-22.6 0l-46.1-46.1-46.1 46.1c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.3-6.3-16.4 0-22.6l46.1-46.1-46.1-46.1c-6.3-6.3-6.3-16.4 0-22.6l22.6-22.6c6.3-6.3 16.4-6.3 22.6 0l46.1 46.1 46.1-46.1c6.3-6.3 16.4-6.3 22.6 0zM552 0c13.3 0 24 10.7 24 24v48c0 13.3-10.8 24-24 24h-195l-97.8 374.5c-9.8 32.5-37 41.5-54.3 41.5-18.6 0-36-8.5-48.4-28.3l-88.9-163.7h-43.6c-13.3 0-24-10.8-24-24v-48c0-13.3 10.8-24 24-24h81.5c10.4 0 23 7.4 28 16.6l58.4 106.1 84.8-322.8c3.7-14.1 16.4-23.9 31-23.9h244.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/square-root-alt.js
// module id = 1939
// module chunks = 0